import { render } from "./Tiles.vue?vue&type=template&id=31838d96&scoped=true&bindings={}"
import script from "./Tiles.vue?vue&type=script&lang=ts"
export * from "./Tiles.vue?vue&type=script&lang=ts"

import "./Tiles.vue?vue&type=style&index=0&id=31838d96&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-31838d96"

export default script